"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchPreview = void 0;
var _mui = require("@ori-ui/mui");
var _searchPreviewProduct = require("@ori/search-preview-product");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _useTranslations = require("../../hooks/useTranslations");
var _getSearchUrl = require("../../utils/getSearchUrl");
var _components = require("./components");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SearchPreview = ({
  numberOfProducts,
  products,
  suggestions,
  query,
  categories,
  brands
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    formatMessage,
    translations
  } = (0, _useTranslations.useTranslations)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.SEARCH_PREVIEW),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Inner, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_searchPreviewProduct.QueryListSection, {
        items: suggestions,
        query: query
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_searchPreviewProduct.QueryListSection, {
        title: formatMessage('brandsX', {
          count: brands.length
        }),
        items: brands,
        query: query,
        showIcon: false
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ProductsSection, {
        products: products,
        query: query,
        title: formatMessage('productsX', {
          count: numberOfProducts
        }),
        showDividerForLastItem: categories.length > 0
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_searchPreviewProduct.QueryListSection, {
        withPaddingBottom: true,
        title: formatMessage('categoriesX', {
          count: categories.length
        }),
        items: categories,
        query: query,
        showIcon: false
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SeeAllResults, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
        fontWeight: "bold",
        textTransform: "uppercase",
        color: "textPrimary",
        "data-testid": getTestId(_constants.SEARCH_PREVIEW_SEE_ALL_RESULTS),
        href: (0, _getSearchUrl.getSearchUrl)(query),
        children: translations.showAllResults
      })
    })]
  });
};
exports.SearchPreview = SearchPreview;